import type { ChatEntry } from '../useAssistant'

type AssistantAnswer = NonNullable<Extract<ChatEntry, { kind: 'turn' }>['assistant']>
type TableSpec = NonNullable<NonNullable<AssistantAnswer['artifacts']>['tables']>[number]

const formatCsvCell = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return ''
  const text = stripMarkdownLinks(String(value))
  return /[",\n\r]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text
}

// Labels may carry backslash-escaped brackets (see MARKDOWN_LINK_PATTERN in
// AssistantTable) — match escape pairs and unescape them so the CSV gets the
// visible label, not the raw markdown.
const stripMarkdownLinks = (text: string): string =>
  text.replace(/\[((?:\\.|[^\]\\])+)]\([^)]+\)/g, (_, label: string) =>
    label.replace(/\\(.)/g, '$1'),
  )

export const buildAssistantTableCsv = (table: TableSpec): string => {
  const lines = [
    table.columns.map(formatCsvCell).join(','),
    ...table.rows.map((row) =>
      table.columns.map((_, columnIndex) => formatCsvCell(row[columnIndex])).join(','),
    ),
  ]
  return lines.join('\n')
}

export const buildAssistantTableCsvFilename = (title: string | undefined): string => {
  const slug = (title || 'assistant-table')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
  return `${slug || 'assistant-table'}.csv`
}
